import React from 'react';
import AdminSiteImageField from './AdminSiteImageField';

const PAGES = [
  { key: 'home', label: 'Home', path: '/' },
  { key: 'shop', label: 'Shop', path: '/shop' },
  { key: 'contact', label: 'Contact', path: '/contact' },
  { key: 'about', label: 'About', path: '/about' },
];

function SeoPageCard({ page, form, setField, sessionToken, onPersistOgImage }) {
  const prefix = `seo_${page.key}`;
  const ogKey = `${prefix}_og_image`;
  const ogHint =
    page.key === 'home'
      ? 'Used when Home is shared on social media. Same image as Content → Hero photo when set there.'
      : `Used when this page is shared on social media. Canonical: salonidesigns.com${page.path}`;

  return (
    <div className="card border shadow-sm mb-3">
      <div className="card-header py-2">
        <h2 className="h6 mb-0">{page.label} page SEO</h2>
      </div>
      <div className="card-body row g-3">
        <div className="col-12">
          <label className="form-label" htmlFor={`${prefix}-title`}>
            Browser title
          </label>
          <input
            id={`${prefix}-title`}
            className="form-control"
            value={form[`${prefix}_title`] || ''}
            onChange={(e) => setField(`${prefix}_title`, e.target.value)}
          />
        </div>
        <div className="col-12">
          <label className="form-label" htmlFor={`${prefix}-desc`}>
            Meta description
          </label>
          <textarea
            id={`${prefix}-desc`}
            className="form-control"
            rows={2}
            value={form[`${prefix}_description`] || ''}
            onChange={(e) => setField(`${prefix}_description`, e.target.value)}
          />
        </div>
        <AdminSiteImageField
          id={`${prefix}-og`}
          label="Social share image (optional)"
          value={form[ogKey] || ''}
          onChange={(v) => setField(ogKey, v)}
          sessionToken={sessionToken}
          aspect="1.91 / 1"
          onPersist={onPersistOgImage ? (path) => onPersistOgImage(ogKey, path) : undefined}
          hint={ogHint}
        />
      </div>
    </div>
  );
}

export default function AdminSiteSeoFields({ form, setField, sessionToken, onPersistOgImage }) {
  return (
    <>
      <p className="small text-muted mb-3">
        Titles and descriptions for search engines and social sharing.
      </p>
      {PAGES.map((page) => (
        <SeoPageCard
          key={page.key}
          page={page}
          form={form}
          setField={setField}
          sessionToken={sessionToken}
          onPersistOgImage={onPersistOgImage}
        />
      ))}
    </>
  );
}
